// extracted by mini-css-extract-plugin
export default {"BottomNav":"BottomNav_BottomNav__MfN2h","active":"BottomNav_active__MDipr"};